export const openAuthenticatedEventStream = (url, onMessage) => {
  const controller = new AbortController();
  let retryDelay = 1_000;

  const waitForRetry = () => new Promise((resolve) => {
    const timer = setTimeout(resolve, retryDelay);
    controller.signal.addEventListener('abort', () => {
      clearTimeout(timer);
      resolve();
    }, { once: true });
  });

  const connect = async () => {
    while (!controller.signal.aborted) {
      try {
        const response = await fetch(url, {
          headers: { Accept: 'text/event-stream' },
          credentials: 'include',
          cache: 'no-store',
          signal: controller.signal,
        });
        if (!response.ok || !response.body) throw new Error('Unable to open update stream.');

        retryDelay = 1_000;
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        while (!controller.signal.aborted) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          const events = buffer.split(/\r?\n\r?\n/);
          buffer = events.pop() || '';
          events.forEach((event) => {
            const data = event.split(/\r?\n/).find((line) => line.startsWith('data: '));
            if (!data) return;
            try {
              onMessage(JSON.parse(data.slice(6)));
            } catch (_error) {
              // Ignore malformed events; the next valid event keeps the stream usable.
            }
          });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (process.env.NODE_ENV !== 'production') console.error(error.message);
      }

      await waitForRetry();
      retryDelay = Math.min(retryDelay * 2, 30_000);
    }
  };

  connect();

  return () => controller.abort();
};
